import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeService, IMesUser } from '@shared/services/mesuser.service';
import { IProductionNote, ProductionNoteService } from '@shared/services/production-note.service';
import { take } from 'rxjs';

@Component({
	selector: 'app-reorder-production-note-list',
	templateUrl: './reorder-production-note-list.component.html',
	styleUrl: './reorder-production-note-list.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ReorderProductionNoteListComponent implements OnInit {
	@Input() alias: string;
	@Input() employees?: IMesUser[];
	displayedColumns = ['sequenceNumber', 'createdAt', 'createdBy', 'note'];
	notes: IProductionNote[] = [];
	orderPos: string;
	frameText: string;
	sashText: string;

	constructor(
		private noteService: ProductionNoteService,
		private employeeService: EmployeeService,
		private translate: TranslateService,
	) {
		this.frameText = this.translate.instant('mes.reorder-note-list.frame');
		this.sashText = this.translate.instant('mes.reorder-note-list.sash');
	}

	ngOnInit(): void {
		const parts = this.alias.split(':');
		this.orderPos = `${parts[0]}:${parts[1]}`;
		this.noteService
			.getProductionNotesByAlias(this.alias)
			.pipe(take(1))
			.subscribe((notes) => {
				this.notes = notes.sort((a, b) => {
					if (a.sequenceNumber === b.sequenceNumber) {
						return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
					}
					return a.sequenceNumber - b.sequenceNumber;
				});
			});

		// Only fetch if employees were NOT injected
		if (!this.employees?.length) {
			this.employeeService
				.getEmployees()
				.pipe(take(1))
				.subscribe((e) => {
					this.employees = e.result;
				});
		}
	}

	getPartInfo(note: string): string {
		const t = note.substring(this.orderPos.length + 1);
		if (t === '') return '';
		if (t[0] === '0') return `${`(${this.frameText} ${t.substring(2)}`.trim()})`;
		return `(${this.sashText} ${t})`;
	}

	public getEmployeeName(code: string): string {
		if (code.includes('@')) return code;
		if (!this.employees) return code;
		const employee = this.employees.find((e) => e.alias === code);
		if (!employee) return code;
		return `(${employee.alias}) ${employee.firstName} ${employee.lastName}`;
	}

	isGroupChange(index: number): boolean {
		if (index === 0) return false;
		const current = this.notes[index];
		const previous = this.notes[index - 1];
		return current.sequenceNumber !== previous.sequenceNumber;
	}
}
